import React from 'react';
import { ArrowUp, ExternalLink, Phone, Mail, Facebook, Youtube, Linkedin, Twitter, Instagram } from 'lucide-react';
const FOOTER_BG = 'https://localcloud.ewubd.edu/backend/uploads/footer/files/1765347722148_1763543163963_footer_file.gif';
const universityLinks = ['Directory', 'Proctor Schedule', 'E-Tender', 'Procurement', 'Gallery', 'Archive', 'Journal and Publications'];
const studentLinks = ['Academic Calendar', 'Payment Procedure', 'Campus Life', 'Convocation', 'Rules & Regulation', 'Faculty Search'];
const quickLinks = ['Apply Online', 'Jobs at EWU', 'Degree Verification', 'Contact Us', 'Inquiry'];
const socials = [{
  icon: Facebook,
  label: 'Facebook'
}, {
  icon: Youtube,
  label: 'YouTube'
}, {
  icon: Linkedin,
  label: 'LinkedIn'
}, {
  icon: Twitter,
  label: 'X'
}, {
  icon: Instagram,
  label: 'Instagram'
}];
function LinkList({
  title,
  items
}: {
  title: string;
  items: string[];
}) {
  return <div data-id="element-58">
      <h3 className="text-base font-bold text-white" data-id="element-59">{title}</h3>
      <ul className="mt-4 space-y-2.5" data-id="element-60">
        {items.map(item => <li key={item} data-id="element-61">
            <a href="#" className="text-sm text-slate-200 transition-colors hover:text-white" data-id="element-62">
              {item}
            </a>
          </li>)}
      </ul>
    </div>;
}
export function Footer() {
  return <footer className="relative overflow-hidden pt-28 text-white" data-id="element-63">
      <img src={FOOTER_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-64" />
      <div className="absolute inset-0 bg-[#0d2340]/90" data-id="element-65" />

      <div className="relative mx-auto max-w-6xl px-4 pb-8 sm:px-6" data-id="element-66">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-67">
          <div className="lg:col-span-1" data-id="element-68">
            <h3 className="text-base font-bold text-white" data-id="element-69">Address</h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-200" data-id="element-70">
              A/2, Jahurul Islam Avenue Jahurul Islam City, Aftabnagar
              Dhaka-1212, Bangladesh
            </p>
            <h3 className="mt-8 text-base font-bold text-white" data-id="element-71">Google Map</h3>
            <a href="#" className="mt-3 flex h-40 w-full items-center justify-center rounded-md bg-white/10 text-sm font-medium text-white ring-1 ring-white/20 transition-colors hover:bg-white/20" data-id="element-72">
              <span className="flex items-center gap-1.5 rounded bg-white/90 px-3 py-1.5 text-[#0f2d5c]" data-id="element-73">
                Open in Maps <ExternalLink className="h-3.5 w-3.5" data-id="element-74" />
              </span>
            </a>
          </div>

          <LinkList title="University" items={universityLinks} data-id="element-75" />
          <LinkList title="Student" items={studentLinks} data-id="element-76" />

          <div data-id="element-77">
            <h3 className="text-base font-bold text-white" data-id="element-78">Quick Links</h3>
            <div className="mt-4 space-y-2.5" data-id="element-79">
              {quickLinks.map(q => <a key={q} href="#" className="block rounded-md border border-white/25 py-2 text-center text-sm text-white transition-colors hover:bg-white/10" data-id="element-80">
                  {q}
                </a>)}
            </div>
          </div>

          <div className="sm:col-span-2 lg:col-span-1" data-id="element-81">
            <h3 className="text-base font-bold text-white" data-id="element-82">Contact Us</h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-200" data-id="element-83">
              <li className="flex items-start gap-2" data-id="element-84">
                <Phone className="mt-0.5 h-4 w-4 shrink-0" data-id="element-85" />
                <span data-id="element-86">
                  Phone no: 09666775577, Ext. - 234
                  <br data-id="element-87" />
                  Hotline: +8801755587224, +8801851933094
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-88">
                <Mail className="mt-0.5 h-4 w-4 shrink-0" data-id="element-89" />
                <span data-id="element-90">admissions@ewubd.edu, info@ewubd.edu</span>
              </li>
            </ul>
            <h3 className="mt-8 text-base font-bold text-white" data-id="element-91">Follow Us</h3>
            <div className="mt-4 flex gap-2.5" data-id="element-92">
              {socials.map(({
              icon: Icon,
              label
            }) => <a key={label} href="#" aria-label={label} className="flex h-9 w-9 items-center justify-center rounded-md border border-white/30 text-white transition-colors hover:bg-white hover:text-[#0f2d5c]" data-id="element-93">
                  <Icon className="h-4 w-4" data-id="element-94" />
                </a>)}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/15 pt-6 sm:flex-row" data-id="element-95">
          <p className="text-xs text-slate-300" data-id="element-96">
            © 2026 East West University. All Rights Reserved.
          </p>
          <div className="flex items-center gap-3" data-id="element-97">
            <span className="text-xs text-slate-300" data-id="element-98">Emergency Hotline</span>
            <div className="flex gap-1.5" data-id="element-99">
              {[0, 1, 2, 3, 4].map(i => <span key={i} className="h-7 w-9 rounded bg-white/90" aria-hidden="true" data-id="element-100" />)}
            </div>
          </div>
        </div>
      </div>

      <button onClick={() => typeof window !== 'undefined' && window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} aria-label="Back to top" className="fixed bottom-6 right-6 z-30 flex h-11 w-11 items-center justify-center rounded-full bg-[#0f2d5c] text-white shadow-lg transition-colors hover:bg-[#123a6b]" data-id="element-101">
        <ArrowUp className="h-5 w-5" data-id="element-102" />
      </button>
    </footer>;
}